export default function Marquee({ items }) {
  const row = [...(items || []), ...(items || [])];
  return (
    <div className="overflow-hidden border-y border-[#E2DDD5] bg-white py-5" data-testid="marquee">
      <div className="flex w-max animate-marquee items-center gap-14 hover:[animation-play-state:paused]">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-14">
            <span className="whitespace-nowrap font-mono text-xs font-medium uppercase tracking-[0.35em] text-[#8896AB]">{item}</span>
            <span className="h-1 w-1 rotate-45 bg-[#B8860B]/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
